import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@sendgrid/style-guide-grid';
import { Radio } from '@sendgrid/ui-components/radio';
import PROFILE from '../constants/profile';
import withProfileInputs from '../containers/withProfileInputs';
import { WriteSelectors } from './roleForm-qa-hooks';

export const RoleForm = ({ profileInputs, setOccupation }) => (
  <div className="container-fluid" data-role="role-container">
    <div className="form-prompt" data-role="role-prompt">
        What is your role?
      {' '}
      <span className="required-dot">&bull;</span>
    </div>
    <div className={Grid.row}>
      <div className={Grid['col-6']}>
        <Radio
          checked={profileInputs.occupation === PROFILE.DEVELOPER}
          data-role="radio-occupation-developer"
          onChange={setOccupation}
          value={PROFILE.DEVELOPER}
          label={PROFILE.DEVELOPER}
          {...WriteSelectors.radioRoleDeveloper}
        />
      </div>
      <div className={Grid['col-6']}>
        <Radio
          checked={profileInputs.occupation === PROFILE.CEO}
          data-role="radio-occupation-ceo"
          onChange={setOccupation}
          value={PROFILE.CEO}
          label={PROFILE.CEO}
          {...WriteSelectors.radioRoleCEO}
        />
      </div>
    </div>
    <div className={Grid.row}>
      <div className={Grid['col-6']}>
        <Radio
          checked={profileInputs.occupation === PROFILE.MARKETER_VALUE}
          data-role="radio-occupation-marketer"
          onChange={setOccupation}
          value={PROFILE.MARKETER_VALUE}
          label={PROFILE.MARKETER}
          {...WriteSelectors.radioRoleMarketer}
        />
      </div>
      <div className={Grid['col-6']}>
        <Radio
          checked={profileInputs.occupation === PROFILE.OTHER}
          data-role="radio-occupation-other"
          onChange={setOccupation}
          value={PROFILE.OTHER}
          label={PROFILE.OTHER}
          {...WriteSelectors.radioRoleOther}
        />
      </div>
    </div>
  </div>
);

RoleForm.propTypes = {
  setOccupation: PropTypes.func.isRequired,
  profileInputs: PropTypes.shape({
    occupation: PropTypes.string.isRequired,
  }).isRequired,
};
export default withProfileInputs(RoleForm);
